<template>
  <v-layout column>
    <v-flex class="mt-3 pl-1 font-weight-bold">{{ group.description }}</v-flex>
    <v-flex v-for="property in group.properties" :key="property.name">
      <Parameter
          :vectorizers="vectorizers"
          :searchParamsBuilders="searchParamsBuilders"
          :compact="compact"
          :showAdvanced="showAdvanced"
          :showDefinedOnly="showDefinedOnly"
          :property="property"
          :languageRestrictions="languageRestrictions"
      ></Parameter>
    </v-flex>
  </v-layout>
</template>

<script>
import Parameter from "./Parameter";

export default {
  props: ["group", "showAdvanced", "showDefinedOnly", "compact", "languageRestrictions", "vectorizers", "searchParamsBuilders"],
  components: {
    Parameter
  }
};
</script>